module.exports = __webpack_public_path__ + "img/icon339.032a05ff.png";